/*
 *  This file is part of dalez/flarum-view-transition
 *
 *  Copyright (c) 2025 DaleZ.
 *
 *  For detailed copyright and license information, please view the
 *  LICENSE-SCRIPT file that was distributed with this source code.
 */

import cachePool from "./cachePool";

export default function hookMithril() {
    // backup the origional functions

    m.route.oldSet = m.route.set;
    m.sync = m.redraw.sync;

    // hook

    m.route.set = (...args) => {
        cachePool.calling = 'true';
        m.route.oldSet(...args);
        return;
    }

    // (what does the codes below do? I just forgot...)

    m.redraw = () => {
            if (!window.pending) {
                window.pending = true;
                window.rAF(function() {
                    pending = false;
                    m.redraw.sync();
                })
            }
        }

    // restore

    m.redraw.sync = m.sync;
}